import styles from './ProductSystemsCatalogCellImage.scss';

import React, { FC } from 'react';

import { ProductSystemsItems } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'src/components/ContentImage/ContentImage';
import { useDesktopOrLarge } from 'src/hooks/UseResponsive';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { Grid } from '../Grid/Grid';

interface ProductSystemsCatalogCellImageProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<ProductSystemsItems>;
}

export const ProductSystemsCatalogImage: FC<ProductSystemsCatalogCellImageProps> = ({
  entry, style = {},
}) => {
  if (!entry) return null;
  const isDesktopOrLarge = useDesktopOrLarge();
  const { backgroundImage, backgroundColor } = entry;
  return (
    <Grid
      item
      justifyContent="center"
      xs={12}
      md={9}
      lg={7}
      xl={6}
      style={!isDesktopOrLarge ? { paddingBottom: 0 } : undefined}
      data-test="product-catalog-grid"
    >
      <div className={styles.productSystemsCatalogCellGrid}>
        <ContentImage
          entry={backgroundImage}
          className={styles.productSystemsCatalogCellImage}
          style={{ ...style, backgroundColor: backgroundColor || style.backgroundColor }}
        />
      </div>
    </Grid>
  );
};
ProductSystemsCatalogImage.displayName = 'ProductSystemsCatalogImage';
